import { Subject } from '~/rage/utils';
import { SpawnPointType } from '~/shared';
import { RpcService } from '../RpcService';
import { VarsService } from '../VarsService';
import { ISpawnSelectService } from './spawnSelectServiceTypes';

export class SpawnSelectService implements ISpawnSelectService {
	private spawnPoints = new Subject<{ name: string; type: SpawnPointType }[]>(
		[],
	);
	private selectedSpawnPointIndex = new Subject<number>(0);

	constructor(
		private readonly vars: VarsService,
		private readonly rpc: RpcService,
	) {
		this.vars
			.get<{ name: string; type: SpawnPointType }[]>('spawnPoints', [])
			.subscribe((spawnPoints) => {
				this.spawnPoints.next(spawnPoints);
				this.selectedSpawnPointIndex.next(spawnPoints.length - 1);
			});
	}

	public getSpawnPoints() {
		return this.spawnPoints;
	}

	public getActiveSpawnPointIndex() {
		return this.selectedSpawnPointIndex;
	}

	public async selectActiveSpawnPoint(): Promise<void> {
		await this.rpc.invokeClient('spawnPointSelection:selectCurrentIndex');
	}

	public async setSpawnPointIndex(index: number): Promise<void> {
		this.selectedSpawnPointIndex.next(index);
		await this.rpc.invokeClient('spawnPointSelection:setCurrentIndex', index);
	}

	public async backToCharacterSelection(): Promise<void> {
		await this.rpc.invokeClient('spawnPointSelection:backToCharacterSelection');
	}
}
